<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-for="item in list" :key="item.diveCenterId" class="diveStoreRect" @click="onSelectDiveCenter(item.diveCenterId)">
      <div class="title"> {{ item.diveCenterName }}</div>
      <div class="NumRect">
        <van-row>
          <van-col span="6"><div class="num">{{ item.teamNum_Wait }}</div>未开班</van-col>
          <van-col span="6"><div class="num">{{ item.teamNum_Begin }}</div>待开班</van-col>
          <van-col span="6"><div class="num">{{ item.teamNum_Run }}</div>进行中</van-col>
          <van-col span="6"><div class="num">{{ item.teamNum_Finish }}</div>已结束</van-col>
        </van-row>
      </div>
      <div class="NumRect">
        <van-row>
          <van-col span="6"><div class="num">{{ item.studentNum_Wait }}</div>待开课</van-col>
          <van-col span="6"><div class="num">{{ item.studentNum_OnCourse }}</div>进行中</van-col>
          <van-col span="6"><div class="num">{{ item.studentNum_Certificate }}</div>待认证</van-col>
          <van-col span="6"><div class="num">{{ item.studentNum_Finished }}</div>已完成</van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '潜水中心顾客管理',
      backurl: '/pro/index',
      loadingPage: false,
      list: []
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.onInit()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onInit() {
      this.loadingPage = true
      request({
        url: '/DiveTrip/getDiveStoreStudentInfoList',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loadingPage = false
        this.list = response.data
      })
    },
    onSelectDiveCenter(id) {
      this.$router.push('/pro/trip/ClassList?coachId=0&diveCenterId=' + id)
    }
  }
}
</script>
<style scoped>
.diveStoreRect{
    background-color: #fff;
    padding: 1em;
    margin:1em;
    border-radius: 0.4em;
}

.diveStoreRect .title{
    font-size: 0.8em;
    font-weight: 700;
}

.diveStoreRect .NumRect{
    text-align: center;
    font-size: 0.7em;
    padding: 0.5em 0;
}

.diveStoreRect .NumRect .num{
    font-size: 2em;
    font-weight: 700;
    padding: 0.3em 0;
}
</style>
